import { localesMessages } from '@rfc/rfc-components-library/locales'

export const commonEn = {
    ...localesMessages.en.common,
    confirmDelete: 'Confirm deletion',
    detail: 'Detail',
    noAction: 'No action available',
    noData: 'No data'
}
